// extracted by mini-css-extract-plugin
export default {"wrapper":"Features_wrapper__rz0Mk","title":"Features_title__ryG+g","description":"Features_description__P1+hm"};